// extracted by mini-css-extract-plugin
export default {"Menu":"contextMenu_Menu__y-nlK","Show":"contextMenu_Show__Rrw0z","Item":"contextMenu_Item__htO1z","Icon":"contextMenu_Icon__KwXd8","Label":"contextMenu_Label__2K9LJ"};